export const iconFontAwesomeEmojiFaceRollingEyes = (
	<i className="fa-solid fa-face-rolling-eyes"></i>
);
